import { Component, OnInit, ViewChild, AfterViewChecked, ChangeDetectorRef, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KbwService } from '@src/app/services/kbwService.service';
import { ExamInfo, ExamBaseData } from '@src/models/examInfo.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from '../../services/messageService.service';
import { Subscription } from 'node_modules/rxjs';
import { environment } from '@src/environments/environment';
import { HeaderComponent } from '../header/header.component';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import {ThemePalette} from '@angular/material/core';
import  Utils  from '../../helpers/Utils';

@Component({
    selector: 'app-trainingselect',
    templateUrl: './trainingselect.component.html',
    styleUrls: ['./trainingselect.component.scss'],
    providers: [KbwService, MessageService],
    standalone: false
})
export class TrainingselectComponent implements OnInit, AfterViewChecked {
  constructor(
    public translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private kbwService: KbwService,
    private messageService: MessageService,
    private cdRef: ChangeDetectorRef,
    ) { }
  @ViewChild(HeaderComponent)
  color: ThemePalette = 'accent';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
  isLoadnig = true;
  bookType = '';
  backBtnVisible = false;
  private headerComp: HeaderComponent;
  trainings: Array<ExamBaseData>;
  selectedExam: number;
  message: string;
  subscription: Subscription;
  langs: any;
  selectedLang: any = 'pl';
  qParam: any;
  public kbklangs = [
    {id: 1, name: 'gb', desc: 'English', code: 'en-GB', order: 2},
    {id: 2, name: 'pl', desc: 'Polski', code: 'pl-PL', order: 1},
    {id: 3, name: 'de', desc: 'Deutsch', code: 'de-DE', order: 3},
    {id: 14, name: 'ro', desc: 'Română', code: 'ro-RO', order: 8},
    {id: 5, name: 'bg', desc: 'Български', code: 'bg-BG', order: 5},
    {id: 10, name: 'hu', desc: 'Magyar', code: 'hu-HU', order: 6},
    {id: 10, name: 'hr', desc: 'Hrvatski', code: 'hr-HR', order: 7},
    {id: 10, name: 'ua', desc: 'Українська', code: 'uk-UA', order: 4},
    {id: 4, name: 'ru', desc: 'Русский', code: 'ru-RU', order: 9}
  ];
  public kbwlangs = [
    {id: 1, name: 'pl', desc: 'Polski', code: 'pl-PL', order: 1},
    {id: 2, name: 'de', desc: 'Deutsch', code: 'de-DE', order: 2},
    {id: 3, name: 'gb', desc: 'English', code: 'en-GB', order: 3},
    //{id: 10, name: 'hu', desc: 'Magyar', code: 'hu-HU', order: 6},
    {id: 10, name: 'ua', desc: 'Українська', code: 'uk-UA', order: 4},
  ];

  ngAfterViewChecked(): void {
    // this.headerComp.isHiddenMenu = true;

    this.cdRef.detectChanges();

  }

  getSpecifiedTrainings() {
    let trainTypes : Array<string>;
    trainTypes = JSON.parse(sessionStorage.getItem('availableTrainings'));
    this.callTrainingTypesExamsApi(this.bookType, trainTypes);
  }
  setLang(langVal){
    this.bookType = Utils.getBookType();
    Utils.setLang(this.translate, langVal, this.bookType);
    this.callExamsApi(this.bookType);
  }
  ngOnInit() {
    sessionStorage.clear();
    this.route.queryParams.subscribe(param => {
      var queryParam = JSON.stringify(param).replace(/"([^"]+)":/g, function($0, $1)
      {
        return ('"' + $1.toLowerCase() + '":');
      });
      this.qParam = JSON.parse(queryParam);

    });
    this.bookType = Utils.getBookType();
    if (sessionStorage.getItem('bookType') === 'SKFRDriver') {
      this.getSpecifiedTrainings();
      return;
    }
    this.subscription = this.messageService.getMessage().subscribe(
      message => {
        this.message = message;
      },
      err => { },
      () => { }
      );
    let bookType = Utils.getBookType();
    if(bookType === 'KBK'){
      this.langs = this.kbklangs;
    } else if(bookType === 'KBW') {
      this.langs = this.kbwlangs;
    } else {
      this.langs = this.kbklangs;
    }
    if(this.qParam['lang']){
      sessionStorage.setItem('lang', this.qParam['lang']);
    }
    if(this.qParam['source'] === 'bookselect'){
      this.backBtnVisible = true;
    }
    Utils.setLang(this.translate, sessionStorage.getItem('lang'), this.bookType);
    this.selectedLang = sessionStorage.getItem('lang')?.substring(3, 5).toLowerCase();

    this.callExamsApi(this.bookType);
  }
  callTrainingTypesExamsApi(bookType, trainingTypes){
    this.isLoadnig = true;
    this.kbwService.postExams<ExamBaseData[]>(bookType, trainingTypes).subscribe(
      (result) => {
        this.trainings = result;
        this.selectedExam = result[0].trainingTypeId;
        sessionStorage.setItem(environment.sessionSelectedExam, result[0].trainingTypeId.toString());
        sessionStorage.setItem(environment.sessionSelectedTrainingFile, result[0].trainingDocument);
        sessionStorage.setItem(environment.sessionSelectedTrainingDesc, result[0].description);
      },
      (err) => {},
      () => {this.isLoadnig = false; }
    );
  }
  callExamsApi(bookType){
    this.isLoadnig = true;
    this.kbwService.getExams<ExamBaseData[]>(bookType).subscribe(
      (result) => {
        this.trainings = result;
        this.selectedExam = result[0].trainingTypeId;
        sessionStorage.setItem(environment.sessionSelectedExam, result[0].trainingTypeId.toString());
        sessionStorage.setItem(environment.sessionSelectedTrainingFile, result[0].trainingDocument);
        sessionStorage.setItem(environment.sessionSelectedTrainingDesc, result[0].description);
      },
      (err) => {},
      () => {this.isLoadnig = false; }
    );
  }
  selectionChanged(value) {
    const train = this.trainings.find(p => p.trainingTypeId === +value);
    const trainingDocName = train.trainingDocument;
    sessionStorage.setItem(environment.sessionSelectedExam, value);
    sessionStorage.setItem(environment.sessionSelectedTrainingFile, trainingDocName);
    sessionStorage.setItem(environment.sessionSelectedTrainingDesc, train.description);
  }
  onClick() {
    this.router.navigate(['/videotraining']);
  }
}
